import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BuildingOfficeIcon, XMarkIcon } from '@heroicons/react/24/outline';
import mspService from '../../services/mspService';

export const MSPImpersonationBar: React.FC = () => {
  const navigate = useNavigate();
  const impersonationData = mspService.getImpersonationData();

  if (!impersonationData) {
    return null;
  }

  const handleReturnToMSPArea = () => {
    mspService.endImpersonation();
    // Restore MSP auth and navigate back
    mspService.initializeAuth();
    navigate('/msp/dashboard');
    window.location.reload(); // Refresh to ensure proper state
  };

  return (
    <div className="bg-indigo-800 text-white px-4 py-2 flex items-center justify-between">
      <div className="flex items-center">
        <BuildingOfficeIcon className="h-5 w-5 mr-2" />
        <span className="text-sm font-medium">
          MSP: {(impersonationData.impersonatedBy as any).partnerCompany || impersonationData.impersonatedBy.mspCompany}
        </span>
      </div>
      <button
        onClick={handleReturnToMSPArea}
        className="flex items-center px-3 py-1 bg-white text-indigo-800 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors"
      >
        <XMarkIcon className="h-4 w-4 mr-1" />
        Return to MSP Area
      </button>
    </div>
  );
};